// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from 'firebase/database';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC3v4ySMDjcnB52tMmz2EKQUoFXgXtHr8M",
  authDomain: "kevatturnaus2025.firebaseapp.com",
  projectId: "kevatturnaus2025",
  databaseURL: 'https://kevatturnaus2025-default-rtdb.europe-west1.firebasedatabase.app',
  storageBucket: "kevatturnaus2025.firebasestorage.app",
  messagingSenderId: "798164565400",
  appId: "1:798164565400:web:9304a95c10eba571757fed",
  measurementId: "G-278TS252QV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app); // Initialize the Firebase Realtime Database

export { db };